/**
 * グローバルヘッダ・フッタ付きのレイアウトコンポーネント
 */
import Head from "next/head"

import CreatorSearchModal from "../../modal/CreatorSearchModal"
import GlobalFooter from "../GlobalFooter"
import GlobalHeader from "../GlobalHeader"
import HTMLHeadForSSR from "src/components/utils/HTMLHeadForSSR"
import URLUtils from "src/utils/URLUtils"
import { siteInfo } from "src/config/siteMeta"

type Props = {
  isCreatorMyPage?: boolean
  isFooter?: boolean
}

const DefaultLayout: React.FC<Props> = ({
  children,
  isCreatorMyPage = false,
  isFooter = true,
}) => {
  return (
    <>
      <Head>
        <meta
          property="og:site_name"
          content={siteInfo.title}
          key="og:site_name"
        />
        <meta name="twitter:site" content="@tieupnovel" key="twitter:site" />
      </Head>
      <HTMLHeadForSSR
        description={siteInfo.description}
        image={URLUtils.getStaticPage(`parts/img/top_og_image.jpg`)}
        title={siteInfo.title}
        twitterCard="summary_large_image"
        type="website"
        url={URLUtils.getRootURLFromEnv()}
      />
      <GlobalHeader isCreatorMyPage={isCreatorMyPage} />
      {children}
      {isFooter && <GlobalFooter />}
      {/* Modals */}
      <CreatorSearchModal />
    </>
  )
}

export default DefaultLayout
